import { isBadManifest, type DeliveryEvent, type DeliveryState } from './deliveryState'

export interface BrokenResult {
  readonly state: DeliveryState
  readonly events: readonly DeliveryEvent[]
}

/**
 * Records that the active bundle failed while the map was in use (a parse or
 * render error, spec §3.6): a downloaded bundle is marked bad — never used
 * again — and the launch marker is cleared, because this was not a crash at
 * launch. The client then launches again to fall back. The bundled map
 * cannot be marked bad; the event still reports it. Port of `delivery.Broken`.
 */
export function broken(input: DeliveryState): BrokenResult {
  const active = input.active
  if (active === undefined) return { state: input, events: [] }
  let reason = 'runtime_error'
  let bad = input.bad
  if (active.manifest === input.bundled.manifest) {
    reason = 'runtime_error_bundled'
  } else if (!isBadManifest(input, active.manifest)) {
    bad = [...bad, active.manifest]
  }
  const { marker: _marker, ...rest } = input
  return {
    state: { ...rest, bad, failures: 0 },
    events: [{ name: 'map_update_bundle_rejected', sequence: active.sequence, reason }],
  }
}
